<template>
    <div class="thank-you-container">
        <v-icon
            size="64"
            class="mb-4"
            color="primary"
        >mdi-check-circle</v-icon>

        <slot>
            <h3 class="text-h5 mb-4">Thank You for Checking In!</h3>

            <p class="text-left mb-4">
                Welcome to Barrel Creek Vineyards, {{ form_data.first_name }}! We're excited to have you
                join us
                today.
                Your information has been securely recorded and you're all set to enjoy your visit.
            </p>

            <p class="text-left mb-4">
                Our team will be notified of your arrival. Please feel free to explore our tasting room
                and don't hesitate to ask our staff about our current wine selections and upcoming events.
            </p>
        </slot>

        <countdown
            ref="countdown"
            :color="color"
            @counter-end="onCounterEnd"
            :counter-override-text="countdown_button_text"
            class="mt-12"
        >
            <template #text="{ countdown }">
                <span>{{ generateCountdownLabelText(countdown) }}</span>
            </template>
        </countdown>
    </div>
</template>

<script>
import Countdown from './countdown.vue';

export default {
    name: 'ThankYou',

    components: {
        Countdown
    },

    props: {
        color: {
            type: String,
            default: 'primary'
        },

        form_data: {
            type: Object,
            required: true
        },

        has_flow_demo_after: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        countdown_button_text() {
            return this.has_flow_demo_after ? 'Show Demo Now' : 'Reset Now';
        }
    },

    methods: {
        generateCountdownLabelText(countdown) {
            return this.has_flow_demo_after
                ? `Showing SMS flow demo in ${countdown} seconds`
                : `Resetting form in ${countdown} seconds`;
        },

        resetForm() {
            if (this.$refs.countdown) {
                this.$refs.countdown.resetCountdown();
            }

            this.$emit('reset-form');
        },

        onCounterEnd() {
            if (this.has_flow_demo_after) {
                this.$emit('show-demo');
            } else {
                this.resetForm();
            }
        }
    },

    mounted() {
        if (this.$refs.countdown) {
            this.$refs.countdown.startCountdown();
        }
    },
};
</script>

<style lang="scss" scoped>
.thank-you-container {
    position: relative;
    text-align: center;
    max-width: min(900px, 90%);
    margin: 4rem auto;
    padding: 3rem 2rem;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 1rem;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-top: 4px solid var(--v-primary-base);
}

@media (max-width: 600px) {

    .form-container,
    .thank-you-container {
        margin: 1rem auto;
        padding: 1.5rem;
        max-width: 95%;
    }
}


:deep(.mdi-check-circle) {
    color: var(--v-primary-base);
}
</style>